// extracted by mini-css-extract-plugin
export default {"container":"CreateMenu_container__3ZTuO","item":"CreateMenu_item__-pibz","icon":"CreateMenu_icon__k0EnZ"};